import en from '../EN/englishInfo'

const currentLanguages = [en]

export default currentLanguages
